export { MemoryRouter as default } from 'react-router';


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router-dom/es/MemoryRouter.js
// module id = 99
// module chunks = 0